/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import {
  Input,
  Select,
  DatePicker,
  Popover,
  Button,
  Radio,
  Space,
  notification,
} from "antd";
import moment from "moment";
import Api from "../../../../services/ServiceApi";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import Renderbtn from "../../../../pages/uih/wf_controllers/BtnController/renderButton";
import { authUserContext } from "../../../../contexts/authContext";
import { isMobile } from "react-device-detect";
import { SearchOutlined, CloseCircleFilled } from "@ant-design/icons";
import { getAreaList } from "../../../../utils/utils";

const { Option, OptGroup } = Select;
const { RangePicker } = DatePicker;

export default function Filter({
  CompanyId,
  OperatorId,
  ProjectId,
  showonlyOwner,
  setshowonlyOwner,
  jobCategory,
  setjobCategory,
  selectJobcategory,
  setselectJobcategory,
  selectPriorityJob,
  setselectPriorityJob,
  selectjobType,
  setselectjobType,
  searchName,
  setsearchName,
  selectSlalevel,
  setselectSlalevel,
  statusDropdown,
  setstatusDropdown,
  setShouldRefresh,
  setformDate,
  settoDate,
  selectAreaCode,
  setselectAreaCode,
  employeeMMDropdown,
  setEmployeeMMDropdown,
  employeeSubDropdown,
  setEmployeeSubDropdown,
  advancedSearchFlag,
  setAdvancedSearchFlag,
}) {
  // ! coding new
  const authUserValue = useContext(authUserContext);
  const [PriorityJob, setPriorityJob] = useState([]);
  const [workflow, setworkflow] = useState([]);
  const [jobType, setjobType] = useState([]);
  const [Slalevel, setSlalevel] = useState([]);
  const [wfProcesslist, setwfProcesslist] = useState([]);
  const [areaCodeList, setareaCodeList] = useState([]);
  const [toggleSelect, settoggleSelect] = useState(false);
  const unmounted = useRef(false);
  const allJobCategory = useSelector((state) => state.metaData.jobCategory);
  const [inputAdvanceSearch, setInputAdvanceSearch] = useState("");
  const [optionViewJob, setOptionViewJob] = useState([
    { value: false, label: "แสดงงานทั้งหมด" },
    { value: true, label: "เฉพาะงานตนเอง" },
  ]);

  const [employeeMMList, setEmployeeMMList] = useState([]);
  const [employeeSubList, setEmployeeSubList] = useState([]);
  const [openPopover, setOpenPopover] = useState(false);
  const [optionAreaList, setOptionAreaList] = useState([]);
  const inputAdvanceSearchRef = useRef();
  // const [placeHolderInputAdvanceSearch, setPlaceHolderInputAdvanceSearch] = useState("ระบุเลข SO ID, Job No, SAP ID")
  const hide = () => {
    setOpenPopover(false);
  };
  const handleOpenPopoverChange = (newOpen) => {
    setOpenPopover(newOpen);
  };
  // console.log('ProjectId', ProjectId);
  // console.log('areaCodeList', areaCodeList);
  // console.log("selectAreaCode", selectAreaCode);
  useMemo(() => {
    if (
      authUserValue.CompanyId === "3" &&
      authUserValue.OperatorId === "3" &&
      ["101", "102"].includes(authUserValue.teamId)
    ) {
      setOptionViewJob([{ value: false, label: "แสดงงานทั้งหมด" }]);
    }
  }, [authUserValue.OperatorId, authUserValue.teamId]);

  useMemo(() => {
    console.log('useMemo > ProjectId', ProjectId);
    const areaListItem = getAreaList(ProjectId);
    setareaCodeList([
      { value: null, label: "All Area Code" },
      ...areaListItem.map((data) => ({
        value: data,
        label: data,
      })),
    ]);
  }, [ProjectId]);

  const GetEmployeeByArea = (areaCodes) => {
    // Api.post("master_data/get_employee_by_area", {
    //   companyId: CompanyId,
    //   operatorId: OperatorId,
    //   projectId: ProjectId,
    //   areaCodes: areaCodes,
    // })
    //   .then((res) => {
    //     if (res.data?.result.code === "P") {
    //       // console.log("get_employee_by_area", res.data);
    //       setEmployeeSubList(res.data?.data);
    //     }
    //   })
    //   .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (openPopover) {
      // inputAdvanceSearchRef.current.focus();
    }
  }, [openPopover]);

  useEffect(() => {
    setjobType([]);
    Api.post("getButtonDetailWeb", {
      WF_ID: 0,
      CompanyID: CompanyId,
      ProjectID: ProjectId,
      JobTypeID: 0,
      Version: 1,
      MainProcessID: "0",
      SubProcessID: "-1",
      ActionID: 1,
      UserName: Cookies.get("username"),
      operator_id: OperatorId,
    })
      .then((res) => {
        setworkflow(res.data.return_nextWorkFlow);
        //fetchWfProcesslist(res.data.return_nextWorkFlow[0]?.wf_id);
      })
      .catch((e) => console.log(e));
    if (allJobCategory.length > 0) {
      setjobCategory(allJobCategory);
    }
    // setareaCodeList([
    //   { value: null, label: "All Area Code" },
    //   ...selectAreaCode.map((data) => ({
    //     value: data,
    //     label: data,
    //   })),
    // ]);
    GetEmployeeByArea(selectAreaCode.map((data) => data));
    // Api.post("master_data/work_area_center", {
    //   company_id: CompanyId,
    //   is_active: "1",
    //   where: "",
    // }).then((res) => {
    //   const { result, data } = res.data;
    //   if (result.code === "P") {
    //     setareaCodeList([
    //       { value: null, label: "All Area Code" },
    //       ...data.result?.map((item) => ({
    //         value: item.area_code,
    //         label: item.area_code,
    //       })),
    //     ]);

    //     GetEmployeeByArea(data.result?.map((item) => item.area_code));
    //   }
    // });
    Api.post("master_data/priority_single", {
      company_id: CompanyId,
      operator_id: OperatorId,
      project_id: ProjectId,
      job_category_id: null,
      job_type_id: null,
    })
      .then((res) => {
        if (res.data?.result.code === "P") {
          setPriorityJob(res.data?.data.result);
        }
      })
      .catch((err) => console.log(err));
    if (selectJobcategory !== null) {
      Api.post("master_data/job_type_single", {
        pk_id: null,
        job_category_name: selectJobcategory === "" ? null : selectJobcategory,
        is_active: "1",
        effective: "1",
        sql_where: null,
        company_id: CompanyId,
        operator_id: OperatorId,
        project_id: ProjectId,
        UserName: Cookies.get("username"),
      })
        .then((res) => {
          if (res.data?.result.code === "P") {
            setjobType(res.data?.data.result);
          }
        })
        .catch((err) => console.log(err));

      //ferchstatus list
      Api.post("master_data/GetWFProcessList", {
        CompanyID: CompanyId,
        OperatorID: OperatorId,
        ProjectID: ProjectId === "" ? null : ProjectId,
        JobCategoryName: selectJobcategory === "" ? null : selectJobcategory,
        EnableGroupStatus: true,
      }).then((res) => {
        const { result, data } = res.data;
        if (result.code === "P") {
          setwfProcesslist(data);
        }
      });
    }

    // if (toggleSelect) {
    Api.post("master_data/sla_single", {
      company_id: CompanyId,
      operator_id: OperatorId,
      project_id: ProjectId,
      job_category_name: selectJobcategory === "" ? null : selectJobcategory,
      job_type_name: selectjobType === "" ? null : selectjobType,
    })
      .then((res) => {
        if (res.data.result.code === "P") {
          setSlalevel(res.data.data.result);
          settoggleSelect(false);
        } else if (res.data.result.code === "F") {
          settoggleSelect(false);
        }
      })
      .catch((e) => {
        console.log(e);
        settoggleSelect(false);
      });
    // }

    // Api.post("master_data/get_all_employee_mm", {
    //   companyId: CompanyId,
    //   operatorId: OperatorId,
    //   projectId: ProjectId,
    // })
    //   .then((res) => {
    //     if (res.data?.result.code === "P") {
    //       // console.log("res.get_all_employee_mm", res.data);
    //       setEmployeeMMList(res.data?.data);
    //     }
    //   })
    //   .catch((err) => console.log(err));
    return () => {
      unmounted.current = true;
    };
  }, [toggleSelect, selectJobcategory]);

  // function fetchWfProcesslist(wfId) {
  //   Api.post("master_data/GetWFProcessList", {
  //     WF_ID: wfId,
  //     EnableGroupStatus: true,
  //   }).then((res) => {
  //     const { result, data } = res.data;
  //     if (result.code === "P") {
  //       setwfProcesslist(data);
  //     }
  //   });
  // }

  function selectMultipleChange(value) {
    console.log('selectMultipleChange', value);
    if (value?.length > 0) {
      if (value[value.length - 1] !== null) {
        setselectAreaCode(value.filter((s) => s !== null));
      } else {
        // setselectAreaCode(authUserValue.userArea);
        setselectAreaCode(getAreaList(ProjectId));
      }
    } else {
      // setselectAreaCode([null]);
      setselectAreaCode([]);
    }

    GetEmployeeByArea(value.filter((s) => s !== null));
    // setShouldRefresh(value);

  }
  function SelectChange(value, type) {
    let typeName = type.name;
    console.log("SelectChange >> typeName", typeName, value);
    if (typeName) {
      switch (typeName) {
        default:
          return null;
        case "Priority":
          setselectPriorityJob(value);
          break;
        case "jobType":
          setselectjobType(value);
          settoggleSelect(true);
          break;
        case "Slalevel":
          setselectSlalevel(value);
          break;
        case "JobCategory":
          setselectJobcategory(value);
          setselectjobType("");
          break;
        case "showonlyOwner":
          setshowonlyOwner(value);
          break;
        case "jobStatus":
          setstatusDropdown(value);
          break;
        case "jobEmployeeMM":
          setEmployeeMMDropdown(value);
          break;
        case "jobEmployeeSub":
          setEmployeeSubDropdown(value);
          break;
      }
    }
    setShouldRefresh(value);
  }
  function onInputSearch(value) {
    if (value) {
      setsearchName(value);
    }
    setOpenPopover(false);
    setShouldRefresh(value);
  }
  function inputAdvanceSearchChange(e) {
    // setsearchName(e.target.value);
    setInputAdvanceSearch(e.target.value);
  }
  function onDatePicker(dates, dateStrings) {
    setformDate(dateStrings[0]);
    settoDate(dateStrings[1]);
    setShouldRefresh(dates);
  }
  const openAddJob = (item) => {
    if (item) {
      window.location.assign(Api.absoluteUrl(`${item.linkto}`));
    }
  };
  function genOption() {
    if (wfProcesslist.length > 0) {
      const Optionheaderraw = wfProcesslist.filter(
        (data) =>
          JSON.parse(data.data_dynamic).configuration.dropdown_status
            .option_type === "group"
      );
      const Optioraw = wfProcesslist.filter(
        (data) =>
          JSON.parse(data.data_dynamic).configuration.dropdown_status
            .option_type === "label"
      );
      Optionheaderraw.sort(function (a, b) {
        return (
          JSON.parse(a.data_dynamic).configuration.dropdown_status.option_seq -
          JSON.parse(b.data_dynamic).configuration.dropdown_status.option_seq
        );
      });
      Optioraw.sort(function (a, b) {
        return (
          JSON.parse(a.data_dynamic).configuration.dropdown_status.option_seq -
          JSON.parse(b.data_dynamic).configuration.dropdown_status.option_seq
        );
      });
      return (
        <>
          {Optionheaderraw && Optionheaderraw.length > 0
            ? Optionheaderraw?.map((data, index) => (
                <OptGroup
                  label={data.process_desc}
                  key={`Option_progress_index_${index}`}
                >
                  {Optioraw && Optioraw.length > 0
                    ? Optioraw?.map((datas, indexs) => {
                        if (
                          JSON.parse(data.data_dynamic).configuration
                            .dropdown_status.option_group_id ===
                          JSON.parse(datas.data_dynamic).configuration
                            .dropdown_status.option_group_id
                        ) {
                          return (
                            <Option
                              name="jobStatus"
                              key={`progress_detail_form_progress_${
                                indexs + 1
                              }`}
                              value={
                                datas.mainProcessID !== null &&
                                datas.subProcessID !== null
                                  ? `${datas.mainProcessID}_${datas.subProcessID}`
                                  : null
                              }
                              // data_dynamic={datas.data_dynamic}
                            >
                              <span className="default-thai-font">
                                {datas.process_desc}
                              </span>
                            </Option>
                          );
                        }
                      })
                    : null}
                </OptGroup>
              ))
            : Optioraw && Optioraw.length > 0
            ? Optioraw?.map((datass, indexss) => (
                <option
                  name="jobStatus"
                  key={`progress_detail_form_progress_${indexss + 1}`}
                  value={`${datass.mainProcessID}_${datass.subProcessID}`}
                  // data_dynamic={datass.data_dynamic}
                >
                  <span className="default-thai-font">
                    {datass.process_desc}
                  </span>
                </option>
              ))
            : null}
        </>
      );
    }
  }
  // function onDropdownVisibleChange(open) {
  //   if (open !== undefined) {
  //     setShouldRefresh(selectAreaCode);
  //   }
  // }
  // console.log("isMobile", isMobile);
  const AddJobBtn = (props) => {
    return (
      // <div className="col-lg-2 col-sm-auto text-right">
      <div>
        {/* <div className="d-flex align-items-end align-content-center flex-column"> */}
        <div className="py-2">
          <Renderbtn
            key={`filter_btn_index_${0}`}
            renderBtn={{
              visible: true,
              html_tag: "button",
              type: "ImagewithText",
              icon_align: "left",
              text: `Add Job`,
              image_path: "/icon/add_job.svg",
              css: "btn btn-xs btn-primary btn-add-job",
            }}
            btnMiddleware={openAddJob}
            index="view_btn_addjob"
            item={{ linkto: "/addjob" }}
            disable={false}
          ></Renderbtn>
        </div>
        {/* </div> */}
      </div>
    );
  };
  const AddJobBtn1 = (props) => {
    return (
      // <div className="col-lg-2 col-sm-auto text-right">
      <div>
        {/* <div className="d-flex align-items-end align-content-center flex-column"> */}
        <div className="py-2">
          {workflow && workflow.length > 0
            ? workflow.map((data, index) => {
                if (data.next_main_action_id === 15) {
                  return (
                    <Renderbtn
                      key={`filter_btn_index_${index}`}
                      renderBtn={{
                        visible: true,
                        html_tag: "button",
                        type: "ImagewithText",
                        icon_align: "left",
                        text: `Add Job`,
                        image_path: "/icon/add_job.svg",
                        css: "btn btn-xs btn-primary btn-add-job",
                      }}
                      btnMiddleware={openAddJob}
                      index="view_btn_addjob"
                      item={{ linkto: "/addjob" }}
                      disable={false}
                    ></Renderbtn>
                  );
                }
              })
            : null}
        </div>
        {/* </div> */}
      </div>
    );
  };
  return (
    <>
      {/* <div className="d-flex justify-content-start flex-wrap"> */}
      <div
        className="malist-filter"
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          alignItems: "center",
          paddingLeft: 12,
        }}
      >
        {isMobile && <AddJobBtn />}
        {/* <div className="col-lg-10 col-sm-auto mr-auto"> */}
        <div>
          <div
            className="row wrapper-search-list"
            style={{ alignItems: "center", height: "100%" }}
          >
            <div>
              <Select
                placeholder="Job Category"
                // className="w-100"
                value={selectJobcategory}
                onChange={SelectChange}
                style={{ width: 150 }}
                dropdownClassName="custom-dropdown"
              >
                <Option value={""} name="JobCategory">
                  <span className="default-thai-font">All Job Category</span>
                </Option>
                {jobCategory && jobCategory.length > 0 ? (
                  jobCategory.map((data, index) => (
                    <Option
                      name="JobCategory"
                      key={`option_filter_priority_job_malist_${index}`}
                      value={data.job_category_name}
                    >
                      <span className="default-thai-font">
                        {data.job_category_name}
                      </span>
                    </Option>
                  ))
                ) : (
                  <Option disabled>
                    <span className="default-thai-font">ไม่พบข้อมูล</span>
                  </Option>
                )}
              </Select>
            </div>
            <div style={{ marginLeft: 5 }}>
              <Select
                placeholder="Job Type"
                // className="w-100"
                value={selectjobType}
                onChange={SelectChange}
                // size="small"
                style={{ width: 150 }}
              >
                <Option value={""} name="jobType">
                  <span className="default-thai-font">All Job Type</span>
                </Option>
                {jobType && jobType.length > 0 ? (
                  jobType.map((data, index) => (
                    <Option
                      name="jobType"
                      key={`option_filter_job_type_malist_${index}`}
                      value={data.job_type_name}
                    >
                      <span className="default-thai-font">
                        {data.job_type_name}
                      </span>
                    </Option>
                  ))
                ) : (
                  <Option disabled>
                    <span className="default-thai-font">ไม่พบข้อมูล</span>
                  </Option>
                )}
              </Select>
            </div>
            {/* <div className="col col-12 col-sm-6 col-md-3 col-lg-2">
              <Select
                placeholder="Job Priority"
                className="w-100"
                value={selectPriorityJob}
                onChange={SelectChange}
              >
                <Option name="Priority" value={0}>
                  <span className="default-thai-font">All Priority</span>
                </Option>
                {PriorityJob && PriorityJob.length > 0 ? (
                  PriorityJob.map((data, index) => (
                    <Option
                      name="Priority"
                      key={`option_filter_priority_job_malist_${index}`}
                      value={data.priority_id}
                    >
                      <span className="default-thai-font">
                        {data.priority_name}
                      </span>
                    </Option>
                  ))
                ) : (
                  <Option disabled>
                    <span className="default-thai-font">ไม่พบข้อมูล</span>
                  </Option>
                )}
              </Select>
            </div> */}
            <div style={{ marginLeft: 5 }}>
              <Select
                placeholder="SLA Level"
                // className="w-100"
                value={selectSlalevel}
                onChange={SelectChange}
                style={{ width: 130 }}
              >
                <Option value={""} name="Slalevel">
                  <span className="default-thai-font">All SLA Level</span>
                </Option>
                {Slalevel && Slalevel.length > 0
                  ? Slalevel.map((data, index) => (
                      <Option
                        name="Slalevel"
                        key={`option_filter_sla_level_malist_${index}`}
                        value={data.sla_name}
                      >
                        <span className="default-thai-font">
                          {data.sla_name}
                        </span>
                      </Option>
                    ))
                  : null}
              </Select>
            </div>
            <div style={{ marginLeft: 5 }}>
              <RangePicker
                showTime={{
                  hideDisabledOptions: true,
                  defaultValue: [
                    moment("00:00", "HH:mm"),
                    moment("23:59", "HH:mm"),
                  ],
                }}
                className="date-range-filter"
                onChange={onDatePicker}
                format={"YYYY-MM-DD HH:mm"}
                style={{ width: 130 }}
              />
            </div>
            <div style={{ marginLeft: 5 }}>
              <Select
                placeholder="Show Owner Only"
                // className="w-100"
                value={showonlyOwner}
                onChange={SelectChange}
                style={{ width: 130 }}
              >
                {optionViewJob.map((item, index) => (
                  <Option name="showonlyOwner" key={index} value={item.value}>
                    <span className="default-thai-font">{item.label}</span>
                  </Option>
                ))}
              </Select>
            </div>
            <div style={{ marginLeft: 5 }}>
              {/* <Select
                placeholder="Select Area"
                mode="multiple"
                name="areaCode"
                className="w-100"
                value={selectAreaCode}
                onChange={selectMultipleChange}
                onDropdownVisibleChange={onDropdownVisibleChange}
              >
                <Option
                  key="areaCode_Option_List_"
                  name="areaCode"
                  value={null}
                >
                  <span className="default-thai-font">All Area Code</span>
                </Option>
                {areaCodeList?.map((s, i) => (
                  <Option
                    key={`areaCode_Option_List_${i}`}
                    name="areaCode"
                    value={s.value}
                  >
                    <span className="default-thai-font">{s.label}</span>
                  </Option>
                ))}
              </Select> */}
              <Select
                allowClear
                mode="multiple"
                placeholder="Select"
                className="ant-select-ellipsis select-area-code"
                value={selectAreaCode}
                onChange={selectMultipleChange}
                maxTagCount={"responsive"}
                style={{ width: 180 }}
              >
                {areaCodeList?.map((s, i) => (
                  <Option key={`multiOption_${i}`} value={s?.value}>
                    <span className="default-thai-font">{s?.label}</span>
                  </Option>
                ))}
              </Select>
            </div>
            <div style={{ marginLeft: 5 }}>
              <Select
                placeholder="Select Job Status"
                //mode="multiple"
                // className="w-100"
                onChange={SelectChange}
                value={statusDropdown}
                showSearch
                style={{ width: 120 }}
              >
                {/* <Option name="jobStatus" value={null}>
                  <span className="default-thai-font">All Job Status</span>
                </Option> */}
                {wfProcesslist && wfProcesslist.length > 0 ? genOption() : null}
                {/* {wfProcesslist && wfProcesslist.length > 0
                  ? wfProcesslist.map((s, i) => (
                      <Option
                        name="jobStatus"
                        key={`wfProcessList_Option_index${i}`}
                        value={`${s.mainProcessID}_${s.subProcessID}`}
                      >
                        <span className="default-thai-font">
                          {s.process_desc}
                        </span>
                      </Option>
                    ))
                  : null} */}
              </Select>
            </div>
            {/* <div className="col col-12 col-sm-6 col-md-6 col-lg-2">
              <Select
                placeholder="Select User MM"
                //mode="multiple"
                className="w-100"
                onChange={SelectChange}
                value={employeeMMDropdown}
                showSearch
              >
                {employeeMMList.map((s, i) => (
                  <Option name="jobEmployeeMM" key={i} value={s.empCode}>
                    <span className="default-thai-font">{s.empCode}</span>
                  </Option>
                ))}
              </Select>
            </div> */}
            {/* <div className="col col-12 col-sm-6 col-md-6 col-lg-2">
              <Select
                placeholder="Select User Sub"
                //mode="multiple"
                className="w-100"
                onChange={SelectChange}
                value={employeeSubDropdown}
                showSearch
              >
                {employeeSubList.map((s, i) => (
                  <Option name="jobEmployeeSub" key={i} value={s.empCode}>
                    <span className="default-thai-font">{s.empCode}</span>
                  </Option>
                ))}
              </Select>
            </div> */}
            <div style={{ marginLeft: 5 }}>
              {/* <Input.Search
                placeholder="Search"
                enterButton
                allowClear
                onChange={inputChange}
                value={searchName}
                onSearch={onInputSearch}
              ></Input.Search> */}
              <Popover
                content={
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: 350,
                      padding: 10,
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <Radio.Group
                        name="radiogroup"
                        onChange={(e) => setAdvancedSearchFlag(e.target.value)}
                        defaultValue={advancedSearchFlag}
                      >
                        <Space direction="vertical">
                          <Radio value={1}>SO ID, Job No, SAP ID</Radio>
                          <Radio value={2}>Site Code</Radio>
                          <Radio value={3}>Job Detail</Radio>
                        </Space>
                      </Radio.Group>
                      <Input
                        ref={inputAdvanceSearchRef}
                        style={{ marginTop: 10 }}
                        placeholder=""
                        enterButton
                        allowClear
                        onChange={inputAdvanceSearchChange}
                        onPressEnter={(e) => onInputSearch(e.target.value)}
                        value={inputAdvanceSearch}
                      ></Input>
                      <div
                        style={{
                          marginTop: 10,
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "end",
                        }}
                      >
                        <Button
                          type="primary"
                          disabled={inputAdvanceSearch.trim().length === 0}
                          onClick={() => onInputSearch(inputAdvanceSearch)}
                        >
                          Search
                        </Button>
                        <Button style={{ marginLeft: 5 }} onClick={hide}>
                          Close
                        </Button>
                      </div>
                    </div>
                  </div>
                }
                title="Advanced Search"
                trigger="click"
                visible={openPopover}
                // open={openPopover}
                onOpenChange={handleOpenPopoverChange}
              >
                {/* <Input
                  readOnly={searchName !== ""}
                  placeholder="Advanced Search"
                  enterButton
                  allowClear
                  onChange={(e) => {
                    const value = e.target.value;
                    setsearchName(value);
                    if (value === "") {
                      setShouldRefresh("");
                    }
                  }}
                  value={searchName}
                  onClick={() => setOpenPopover(true)}
                  prefix={<SearchOutlined />}
                ></Input> */}
                <div
                  style={{
                    display: "flex",
                    width: 160,
                    backgroundColor: "white",
                  }}
                >
                  <Input
                    className="input-advance-search"
                    readOnly={true}
                    placeholder="Advanced Search"
                    enterButton
                    // allowClear
                    // onChange={(e) => {
                    //   const value = e.target.value;
                    //   setsearchName(value);
                    //   if (value === "") {
                    //     setShouldRefresh("");
                    //   }
                    // }}
                    style={{ width: 150 }}
                    value={searchName}
                    onClick={() => setOpenPopover(true)}
                    prefix={<SearchOutlined />}
                  ></Input>
                  {searchName && (
                    <CloseCircleFilled
                      style={{ color: "#C1C1C1", margin: 5 }}
                      onClick={() => {
                        setsearchName("");
                        setShouldRefresh("");
                      }}
                    />
                  )}
                </div>
              </Popover>
            </div>
          </div>
        </div>
        {!isMobile && ProjectId && <AddJobBtn />}
      </div>
    </>
  );
}
